export const GET_CA_LIST = 'GET_CA_LIST'
